import { ca } from '@cian/analytics';

export function trackBuilderLogoClick({
  realtyUserId,
  builderCardUrl,
  title,
}: {
  realtyUserId: number;
  builderCardUrl: string;
  title: string;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_card_builder',
    page: {
      extra: {
        is_specproject: true,
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
